<template>
  <div class="full-width">
    <script type="application/ld+json">
      {
        "@context": "http://schema.org",
        "@graph": [
          {
            "@type": "Article",
            "url": "https://www.teddi.co/login/",
            "headline": "Connexion ← Teddi",
            "description": "Connectez-vous à votre compte pour suivre vos recherches immobilières.",
            "datePublished": "2020-04-10T17:47:50.000Z",
            "dateModified": "2019-04-11T09:20:51.000Z",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://www.teddi.co/login/"
            },
            "publisher": {
              "@type": "Organization",
              "@id": "https://www.teddi.co/",
              "name": "Teddi",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.teddi.co/assets/socials/fb-profile.png",
                "width": 1000,
                "height": 1000
              }
            },
            "author": {
              "@type": "Person",
              "name": "Thomas"
            }
          }
        ]
      }
    </script>
    <b-row class="center">
      <b-col md="3" class="mx-auto">
        <b-form @submit.prevent="retrieveToken">
          <h2 class="mb-4">Se connecter</h2>

          <b-form-input
            v-model="email"
            type="email"
            required
            ref="input"
            lazy
            placeholder="E-mail"
            class="mb-4"
          ></b-form-input>

          <b-form-input
            v-model="password"
            type="password"
            required
            lazy
            placeholder="Mot de passe"
            class="mb-4"
          ></b-form-input>

          <b-button class="btn text-uppercase px-4 py-2 btn-block" type="submit"
            >Connexion</b-button
          >
        </b-form>
        <div class="d-flex flex-column links mt-3">
          <router-link class="mb-2" :to="{ name: 'register' }">
            S'inscrire
          </router-link>
          <router-link :to="{ name: 'request-new-password' }">
            Mot de passe oublié ?
          </router-link>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Vue from "vue";

export default {
  metaInfo: {
    title: "Connexion",
    titleTemplate: "%s ← Teddi",
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content: "Connectez-vous à votre compte pour accéder à votre recherche immobilière.",
      },
      {
        property: "og:title",
        content: "Connexion ← Teddi",
      },
      { property: "og:site_name", content: "Teddi" },
      { property: "og:type", content: "website" },
      {
        property: "og:url",
        content: "https://www.teddi.co/login",
      },
      {
        property: "og:image",
        content: "https://www.teddi.co/assets/socials/fb-cover.jpg",
      },
      {
        property: "og:description",
        content: "Connectez-vous à votre compte pour accéder à votre recherche immobilière.",
      },
    ],
    link: [{ rel: "canonical", href: "https://www.teddi.co/login" }],
  },

  computed: {
    ...mapState(["loading"]),
    email: {
      get() {
        return this.$store.state.userData.email;
      },
      set(value) {
        this.$store.commit("SET_EMAIL", value);
      },
    },
    password: {
      get() {
        return this.$store.state.password;
      },
      set(value) {
        this.$store.commit("SET_PASSWORD", value);
      },
    },
  },
  methods: {
    ...mapActions(["retrieveToken"]),
    focus() {
      this.$refs.input.$el.focus();
    },
  },
  mounted() {
    this.focus();
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/forms.scss";
@import "@/styles/buttons.scss";

.links {
  a,
  a:hover {
    color: $blue;
  }
}
.form-control {
  padding: 13px !important;
}
.btn {
  font-weight: bold;
  background-color: $blue;
  color: white;
  transition: transform 0.3s ease-out;
  &:hover {
    transform: translate(0, -2px);
    background-color: $blue;
  }
}
.btn.disabled {
  background-color: $blue;
}

.full-width {
  display: table;
  width: 100%;
  margin: 0 auto;
  height: 75%;
  left: 0;
  position: absolute;
}
.center {
  display: table-cell;
  width: 50%;
  max-width: 100%;
  vertical-align: middle;
}
::v-deep {
  .submitting {
    cursor: not-allowed !important;
    svg {
      height: 100%;
      width: 4rem;
      path {
        transform: scale(1) !important;
        fill: transparent !important;
        stroke: white !important;
      }
    }
  }
}
</style>
